import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper';

domReady(() => {
  const cardsGroupCarousels = document.querySelectorAll(
    '.cards-group-swiper .cards-group__inner'
  );

  if (0 < cardsGroupCarousels.length) {
    cardsGroupCarousels.forEach((cardsGroupCarousel) => {
      new Swiper(cardsGroupCarousel, {
        slidesPerView: 1,
        slidesPerSwipe: 1,
        spaceBetween: 20,
        pagination: {
          el: '.cards-group__inner .vtx-swiper__pagination',
          type: 'fraction',
        },
        navigation: {
          nextEl: '.cards-group__inner .vtx-swiper__next',
          prevEl: '.cards-group__inner .vtx-swiper__prev',
        },
        breakpoints: {
          980: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          1400: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
        },
      });

      if (cardsGroupCarousel.swiper.slidesGrid.length > 3) {
        cardsGroupCarousel.classList.add('swiper-container');
      }
    });
  }
});
